export default {
    mounted() {
        this.audio = this.el.querySelector("#native-audio");
        this.playBtn = this.el.querySelector("#play-btn");
        this.progressContainer = this.el.querySelector("#progress-container");
        this.progressFill = this.el.querySelector("#progress-fill");
        this.currentTimeEl = this.el.querySelector("#current-time");
        this.durationEl = this.el.querySelector("#duration");

        this.iconPlay = this.el.querySelector("#icon-play");
        this.iconPause = this.el.querySelector("#icon-pause");

        // 1. Toggle Play/Pause
        this.playBtn.addEventListener("click", () => {
            if (this.audio.paused) {
                this.audio.play();
            } else {
                this.audio.pause();
            }
        });

        // 2. Update UI on Play/Pause State Change
        this.audio.addEventListener("play", () => this.toggleIcons(true));
        this.audio.addEventListener("pause", () => this.toggleIcons(false));

        // 3. Update Progress Bar & Time as it plays
        this.audio.addEventListener("timeupdate", () => {
            const percent = (this.audio.currentTime / this.audio.duration) * 100;
            this.progressFill.style.width = `${percent}%`;
            this.currentTimeEl.innerText = this.formatTime(this.audio.currentTime);
        });

        // 4. Set Duration when metadata loads
        this.audio.addEventListener("loadedmetadata", () => {
            this.durationEl.innerText = this.formatTime(this.audio.duration);
        });

        if (this.audio.readyState >= HTMLMediaElement.HAVE_METADATA) {
            this.durationEl.innerText = this.formatTime(this.audio.duration);
        }

        // 5. Seek functionality (Clicking the bar)
        this.progressContainer.addEventListener("click", (e) => {
            const rect = this.progressContainer.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const width = rect.width;
            const percent = clickX / width;

            this.audio.currentTime = percent * this.audio.duration;
        });

        // 6. Reset when audio ends
        this.audio.addEventListener("ended", () => {
            this.toggleIcons(false);
            this.progressFill.style.width = "0%";
            this.currentTimeEl.innerText = "0:00";
        });
    },

    toggleIcons(isPlaying) {
        if (isPlaying) {
            this.iconPlay.classList.add("hidden");
            this.iconPause.classList.remove("hidden");
        } else {
            this.iconPlay.classList.remove("hidden");
            this.iconPause.classList.add("hidden");
        }
    },

    formatTime(seconds) {
        if (!seconds || isNaN(seconds)) return "0:00";
        const m = Math.floor(seconds / 60);
        const s = Math.floor(seconds % 60);
        return `${m}:${s < 10 ? "0" : ""}${s}`;
    },
};
